module.exports = __webpack_public_path__ + "img/newenergyconference-m.ebdf9ba9.png";